import { Button, Stack, Typography } from '@common-components';
import { FastForwardOutlined as FastForwardOutlinedIcon } from '@icons';
import { PlacementTask } from 'enums';
import { useCompletePlacementTask } from 'hooks';
import { messages } from 'i18n';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';

export default function CompleteMarketingBanner() {
  const { completeMarketingBanner } = messages.submissionWorkspace;
  const { partialSubmission, reFetchWorkspace } = useSubmissionsWorkspace();
  const { completePlacementTask } = useCompletePlacementTask();

  const handleCompleteMarketing = async () => {
    await completePlacementTask(partialSubmission!, PlacementTask.Remarketing, {
      onSuccess: reFetchWorkspace,
    });
  };

  if (!partialSubmission) {
    return null;
  }

  return (
    <Stack direction="row" gap={1} my={1} py={1} px={1.5} alignItems="center" bgcolor="green.300">
      <Stack direction="row" alignItems="flex-start" flex={1}>
        <Stack overflow="hidden">
          <Typography noWrap variant="body2Bold" color="text.primary">
            {completeMarketingBanner.title}
          </Typography>
          <Typography variant="caption" color="text.primary">
            {completeMarketingBanner.description}
          </Typography>
        </Stack>
      </Stack>
      <Button
        size="medium"
        color="inherit"
        variant="outlined"
        startIcon={<FastForwardOutlinedIcon />}
        onClick={handleCompleteMarketing}
      >
        {completeMarketingBanner.button}
      </Button>
    </Stack>
  );
}
